import commonApi from './CommonApi.js';
export default {
	browse: async (parameters) => {
		return await commonApi().get('/parties/browse', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getDropdownItems: async (parameters) => {
		return await commonApi().get('/parties/get-dropdown-items', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getAll: async (parameters) => {
		return await commonApi().get('/parties', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getPartiesByAnnexNumber: async (parameters) => {
		return await commonApi().get('/parties/get-parties-by-annex-number', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getById: async (parameters) => {
		return await commonApi().get('/parties/id', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	save: async (viewModel) => {
		return await commonApi().post('/parties', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error.response);
				if (error.response.data.status === 400) {
					return error.response.data;
				}
				else {
					console.log(error.response);
				}
			});
	},
	processFile: async (viewModel) => {
		return await commonApi().post('/parties/process-file', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error.response);
				if (error.response.data.status === 400) {
					return error.response.data;
				}
				else {
					console.log(error.response);
				}
			});
	},
	publish: async (viewModel) => {
		return await commonApi().post('/parties/publish', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	testEntity: async (parameters) => {
		return await commonApi().get('/parties/test-entity', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	testNote: async (parameters) => {
		return await commonApi().get('/parties/test-note', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getWtoAppendixItems: async (parameters) => {
		return await commonApi().get('/parties/get-wto-appendix-items', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	}
}